import { render } from "./IntegrationsPage.vue?vue&type=template&id=8f78b1f6&scoped=true"
import script from "./IntegrationsPage.vue?vue&type=script&lang=js"
export * from "./IntegrationsPage.vue?vue&type=script&lang=js"

import "./IntegrationsPage.vue?vue&type=style&index=0&id=8f78b1f6&scoped=true&lang=css"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-8f78b1f6"]])

export default __exports__